import React, {useCallback, useContext, useEffect, useMemo, useState} from "react";
import {AuthContext} from "contexts";
import {adminsService, AdminUser} from "services/adminsService";
import {CreateAdminButton} from "pages/Admins/components/CreateAdminButton";
import {EditAdminAccessModal} from "pages/Admins/components/EditAdminAccessModal";
import Swal from 'sweetalert2';
import withReactContent from "sweetalert2-react-content";
import toast from "react-hot-toast";
import {AgGridReact} from "ag-grid-react";
import {useAdminsTable} from "pages/Admins/useAdminsTable";
import {useWindowDimensions} from "hooks";
const MySwal = withReactContent(Swal);

export const AdminsPage = () => {
    const {env} = useContext(AuthContext);
    const {height} = useWindowDimensions();

    const [admins, setAdmins] = useState<AdminUser[]>([]);
    const [accessModalAdmin, setAccessModalAdmin] = useState<AdminUser | null>(null);

    const reload = useCallback(() => {
        env && adminsService.getAll(env).then(as => setAdmins(as))
    }, [env]);

    const handleBlockAdmin = useCallback(async (key: string, name: string) => {
        if (!env) {
            return
        }
        const result = await MySwal.fire({
            title: `Заблокировать ${name}?`,
            confirmButtonText: 'Да',
            confirmButtonColor: '#D9292E',
            cancelButtonText: 'Нет',
            showCancelButton: true,
            showConfirmButton: true,
        });
        if (result.isConfirmed) {
            await adminsService.block(key, env)
            reload()
        }
    }, [env, reload]);

    const handleRegenerateToken = useCallback(async (key: string, name: string) => {
        if (!env) {
            return
        }
        const result = await MySwal.fire({
            title: `Обновить токен для админа ${name}?`,
            confirmButtonText: 'Да',
            confirmButtonColor: '#D9292E',
            cancelButtonText: 'Нет',
            showCancelButton: true,
            showConfirmButton: true,
        });
        if (result.isConfirmed) {
            await adminsService.regenerate(key, env)
            reload()
        }
    }, [env, reload]);

    const copyToken = useCallback(async (token: string) => {
        try {
            await navigator.clipboard.writeText(token)
            toast.success("Токен скопирован")
        } catch {
            toast.error("Не получилось скопировать токен")
        }
    }, []);

    const openAccessModal = useCallback((admin: AdminUser) => {
        setAccessModalAdmin(admin)
    }, []);

    const tableHandlers = useMemo(
        () => ({
            onBlock: handleBlockAdmin,
            onRegenerate: handleRegenerateToken,
            onEditAccess: openAccessModal,
            onCopyToken: copyToken,
        }),
        [handleBlockAdmin, handleRegenerateToken, openAccessModal, copyToken],
    );

    const {columnDefs} = useAdminsTable(tableHandlers);

    useEffect(() => {
        reload()
    }, [reload]);

    return <div className="d-flex flex-column align-items-center w-100 mt-2">
        <EditAdminAccessModal
            admin={accessModalAdmin}
            show={accessModalAdmin != null}
            onHide={() => setAccessModalAdmin(null)}
            onSaved={reload}
        />
        <div className="w-75 d-flex flex-column align-items-end">
            <div className="d-flex flex-column align-items-end">
                <CreateAdminButton onAdminCreated={reload}/>
                <div className="mt-1 mb-2 small">
                    Права по ролям <a
                    href={"https://www.notion.so/Support-roles-and-rights-2b790b658690805bb881e73c08343a99"}
                    target="_blank" rel="noreferrer">Notion</a>
                </div>
            </div>
            <div className="mt-2 w-100" style={{height: height - 150, width: '100%'}}>
                <AgGridReact<AdminUser>
                    pagination={true}
                    paginationPageSize={50}
                    rowData={admins}
                    columnDefs={columnDefs}
                    getRowId={(p) => p.data.userKey}
                />
            </div>
        </div>
    </div>
}
